export function keyStoreApiBaseUrl(): string {
  const configured = import.meta.env.VITE_KEY_STORE_API_BASE_URL as string | undefined;
  const base = configured?.trim() ? configured.trim() : "https://api.key.store";
  return base.replace(/\/$/, "");
}

export class KeyStoreApiError extends Error {
  readonly status: number;
  readonly method: string;
  readonly path: string;

  constructor(method: string, path: string, status: number, statusText: string) {
    const suffix = statusText ? ` ${statusText}` : "";
    super(`${method} ${path} failed with HTTP ${status}${suffix}`);
    this.name = "KeyStoreApiError";
    this.status = status;
    this.method = method;
    this.path = path;
  }
}

export async function postJson<TResponse>(
  path: string,
  body: unknown,
  options: { signal?: AbortSignal; headers?: Record<string, string> } = {},
): Promise<TResponse> {
  const response = await fetch(`${keyStoreApiBaseUrl()}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers ?? {}),
    },
    body: JSON.stringify(body),
    signal: options.signal,
  });

  if (!response.ok) {
    throw new KeyStoreApiError("POST", path, response.status, response.statusText);
  }

  return (await response.json()) as TResponse;
}

export async function getJson<TResponse>(
  path: string,
  options: { signal?: AbortSignal; headers?: Record<string, string> } = {},
): Promise<TResponse> {
  const response = await fetch(`${keyStoreApiBaseUrl()}${path}`, {
    method: "GET",
    headers: options.headers ?? {},
    signal: options.signal,
  });

  if (!response.ok) {
    throw new KeyStoreApiError("GET", path, response.status, response.statusText);
  }

  return (await response.json()) as TResponse;
}
